import React from "react";
import HeroBG from "../assets/request-hero.jpg";
import "./Styles/Request.css";

const Request = () => {
  const openWhatsapp = () => {
    const phone = "+9613729086"; // ton num ro WhatsApp
    const message = encodeURIComponent("Hello! I would like to customize a product.");
    const url = `https://wa.me/${phone}?text=${message}`;
    window.open(url, "_blank");
  };

  return (
    <div className="request-container">
      {/* HERO */}
      <div className="hero">
        <div className="imageWrapper">
          <img src={HeroBG} alt="Custom design showcase" className="bg-image" />
        </div>
        <div className="hero-content">
          <h1>Request a Customize</h1>
          <div className="breadcrumb">
            <a href="/">Home</a> <span>Request</span>
          </div>
        </div>
      </div>

      {/* BOUTON WHATSAPP */}
      <div className="form-wrapper">
        <h2 className="form-title">Customize Your Product</h2>
        <button className="whatsappBtn" onClick={openWhatsapp}>
          Contact us on WhatsApp
        </button>
      </div>
    </div>
  );
};

export default Request;
